import { makeStyles } from '@material-ui/core/styles';

const styles = (theme) => ({
  warning: {
    color: theme.colorPalette.green_30,
    fontSize: 14,
    lineHeight: 1.4
  },
  link: {
    color: theme.colorPalette.green_30,
    textDecoration: 'underline'
  }
});

export default makeStyles(styles);
